import { inject } from '@angular/core';
import { CanDeactivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmDialogSharedComponent } from 'src/app/shared/dialog/confirm-dialog-shared/confirm-dialog-shared.component';
import { AuthStore } from '../store/auth/auth.store';

export const eseguiAttivitaDeactivateGuard: CanDeactivateFn<any> = (
  component: any,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot | undefined
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

  const _dialogService = inject(DialogService);
  const _authStore = inject(AuthStore);

  // Se l'utente non è più autenticato (es. logout forzato), permettiamo la deattivazione
  if (!_authStore.isAuthenticated()) {
    return true;
  }

  // Se la navigazione è stata avviata programmaticamente (es. dopo eseguiAttivita), bypass del dialogo
  if (component?.canDeactivateWithoutConfirm) {
    return true;
  }

  return new Promise((resolve) => {
   
    const ref = _dialogService.open(ConfirmDialogSharedComponent, {
      header: 'Attenzione',
      width: '500px',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      closable: true,
      // TODO: translate
      data: {
        message: 'Uscendo perderai i dati dell\'attività. Sei sicuro di voler uscire?',
        icon: 'pi-exclamation-triangle',
        confirmLabel: 'Si, sono sicuro',
        cancelLabel: 'No, non sono sicuro',
        confirmSeverity: 'primary'
      }

    });


    ref?.onClose.subscribe(async (result) => {
      if (result) {
        resolve(true);
      } else {
        resolve(false);
      }
    });

  });
}
